<template>
    <div class="card" v-if="collections && collections.length > 0">
        <header class="card-header">
            <p class="card-header-title">
                Project Data
            </p>
        </header>
        <div class="card-content menu">
            <div class="menu-label is-flex is-vcentered columns">
                <img
                    :src="
                        `${ASSETS_BASE_URL}datamodel/icons/SVG/coll-light.svg`
                    "
                    alt="BossDB Collection Icon"
                    style="height: 1.7em; padding-right: 10px"
                />
                <div>Collections</div>
            </div>
            <ul class="menu-list">
                <li v-for="collection in collections">
                    <div class="is-flex v-centered">
                        <a @click="collection.show = !collection.show">
                            <!-- Vue.js 'v-if' and Bulma <i> did not play nice together -->
                            <span v-show="collection.show" class="icon">
                                <i
                                    class="fa fa-caret-down fa-lg has-text-black"
                                    key="down"
                                ></i>
                            </span>
                            <span v-show="!collection.show" class="icon">
                                <i
                                    class="fa fa-caret-right fa-lg has-text-black"
                                    key="right"
                                ></i>
                            </span>
                        </a>
                        <MetadataLink
                            :metadata="collection"
                        />
                    </div>

                    <div v-if="collection.show">
                        <ul class="menu-list">
                            <li class="menu-label is-flex is-vcentered">
                                <img
                                    :src="
                                        `${ASSETS_BASE_URL}datamodel/icons/SVG/exp-light.svg`
                                    "
                                    alt="BossDB DataType Icon"
                                    style="height: 1.7em; padding-right: 10px"
                                />
                                <div class="label-color">Experiments</div>
                            </li>
                            <li
                                class="indented"
                                v-for="experiment in collection.experiments.slice(
                                    0,
                                    collection.displayRange
                                )"
                            >
                                <ExperimentDropdown :exp="experiment" />
                            </li>
                            <template
                                v-if="
                                    collection.experiments.length >
                                        collection.displayRange + 1
                                "
                            >
                                <li class="indented">
                                    <a
                                        @click="
                                            collection.displayRange += maxItems
                                        "
                                        >...</a
                                    >
                                </li>
                                <li class="indented">
                                    <ExperimentDropdown
                                        :exp="
                                            collection.experiments.slice(-1)[0]
                                        "
                                    />
                                </li>
                            </template>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { ASSETS_BASE_URL } from "@/assets.js";
import MetadataRemote from "@/metadata.js";
import ExperimentDropdown from "./ExperimentDropdown.vue";
import MetadataLink from "./MetadataLink.vue";

export default {
    name: "DataCard",
    props: {
        collection_ids: {
            type: Array,
            required: true
        }
    },

    components: {
        MetadataLink,
        ExperimentDropdown
    },

    created() {
        let metadataRemote = new MetadataRemote();
        let metadataUrl = metadataRemote.getWebsiteUrl();
        this.collections = [];
        this.maxItems = 10;

        this.collection_ids.forEach(collection_id => {
            metadataRemote
                .getCollection(collection_id)
                .then(blob => {
                    this.collections.push({
                        id: blob.attributes.ID,
                        name: blob.attributes.ID,
                        metadataUrl: `${metadataUrl}/Collection/${blob.id}`,
                        experiments: [],
                        show: false,
                        displayRange: this.maxItems - 1
                    });

                    this.collections.forEach(collection => {
                        metadataRemote
                            .getExperimentsByCollection(collection.id)
                            .then(blob => {
                                collection.experiments.push(
                                    ...blob.map(b => {
                                        return {
                                            id: b.attributes.ID,
                                            name: b.attributes.Name,
                                            metadataUrl: `${metadataUrl}/Experiment/${b.id}`,
                                            channels: [],
                                            show: false,
                                            displayRange: this.maxItems - 1
                                        };
                                    })
                                );

                                collection.experiments.forEach(experiment => {
                                    metadataRemote
                                        .getChannelsByExperiment(experiment.id)
                                        .then(blob => {
                                            experiment.channels.push(
                                                ...blob.map(b => {
                                                    return {
                                                        id: b.attributes.ID,
                                                        name: b.attributes.Name,
                                                        metadataUrl: `${metadataUrl}/Channel/${b.id}`,
                                                        show: false
                                                    };
                                                })
                                            );
                                        })
                                        .catch(error => {
                                            console.error(
                                                `Unable to find meatdata for channels. ${error}`
                                            );
                                        });
                                });
                            })
                            .catch(error => {
                                console.error(
                                    `Unable to find meatdata for experiments. ${error}`
                                );
                            });
                    });
                })
                .catch(error => {
                    console.error(
                        `Unable to find meatdata for collection ${collection_id}. ${error}`
                    );
                });
        });
    },
    data() {
        return {
            ASSETS_BASE_URL,
            collections: this.collections,
            maxItems: this.maxItems
        };
    }
};
</script>

<style lang="scss">
.y-margin {
    margin-top: 5px;
    margin-bottom: 5px;
}

.indented {
    margin-left: 1.2em;
}

.label-color {
    color: #7a7a7a;
}
</style>
